export const SAVED_QUERY_ANALYTICS = {
  "SAVED_QUERY: Viewed List": () => ({}),
  "SAVED_QUERY: Saved query": () => ({}),
  "SAVED_QUERY: Applied Query": () => ({}),
  "SAVED_QUERY: Saved Changes": () => ({}),
  "SAVED_QUERY: Deleted": () => ({}),
};
